import React from 'react';
import './Landing.css';

function Buycalapes() {
  return (
    <div className="calLanding">
      <div className="cal-apesLanding">
        <h2>Buy $CALAPES</h2>

        <p className="calTagline">
        Join the $CALAPES community—turning chaos into change! 
        <br />
        Every $CALAPES you hold helps fund California wildfire relief efforts and supports recovery in fire-stricken areas.
        </p>
        <a href="https://raydium.io/swap/?inputMint=sol&outputMint=9RGMt6ZWrtybcYt3mup6QBwyz9KtQ4tbx9naNSByPvfx" className="enterCAL" target="_blank" rel="noopener noreferrer">
            Buy $CALAPES
          </a>
      </div>
    </div>
  );
}

export default Buycalapes;